import React from 'react';
import connectField    from 'uniforms/connectField';
import {createElement} from 'react';

const ReadOnlyTextBottom = (props) => {
    return(
        <div className={'form-bg-light-grey'} style={{paddingTop: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0, margin: 0}}>
            <div className={'form-bg-dark-grey'} style={{borderTopLeftRadius: 0, borderTopRightRadius: 0, marginTop: 0, paddingTop: 3}}>
                {createElement(props.tag, {dangerouslySetInnerHTML: {__html: props.html ? props.html : props.label}})}
            </div>
        </div>
    );
}

ReadOnlyTextBottom.defaultProps = {
    tag: 'div'
};

export default connectField(ReadOnlyTextBottom);
